// TODO consolidate the two types: DeployStatus and FetchStatus

export enum FetchStatus {
  Fetching = 'fetching',
  InitialFetching = 'initial_fetching',
  Error = 'error',
  Fetched = 'fetched',
  InvalidCredentials = 'invalid_credentials',
}
